export const idTypes = {
  FIN: 'FIN',
  NRIC: 'NRIC',
};
